<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important">
  <span>{{ 'enterprise_contract.lot_setup_sign_flow_title' | translate }}</span>
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>

<div class="row py-1 mt-2">
  <div class="col-12">
    <span class="highligth">
      <em [innerHTML]="countText"></em>
    </span>
  </div>
</div>

<mat-dialog-content class="table-container example-container" style="max-height: 300px">
  <mat-table [dataSource]="listData">
    <!-- STT -->
    <ng-container matColumnDef="STT">
      <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
        {{'enterprise_contract.table_headers.No' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element, let i = index" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
        {{element.order ? element.order : i + 1}}
      </mat-cell>
    </ng-container>

    <!-- Tên tài liệu Column -->
    <ng-container matColumnDef="contractName">
      <mat-header-cell *matHeaderCellDef style="max-width: 20%" class="mat-cell-non-boder-right-bottom">
        {{'headertable.document_code_name' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="max-width: 20%" matTooltip="{{element.contractNameCode ? element.contractNameCode :(element.name ? element.name: element.contractName) }}" class="mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
        <span class="fix-width">{{element.contractNameCode ? element.contractNameCode : (element.contractName ? element.contractName : element.name)}}</span>
      </mat-cell>
    </ng-container>

    <!-- result Column -->
    <ng-container matColumnDef="result">
      <mat-header-cell *matHeaderCellDef style="max-width: 15%;" class="mat-cell-non-boder-right-bottom">
        {{'headertable.sign_result' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="max-width: 15%;"
                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom">
        <span class="fix-width text-center" [ngStyle]="renderStatusColor(element.status)">{{renderStatus(element.status)}}</span>
      </mat-cell>
    </ng-container>

    <!-- Người chuyển Column -->
    <ng-container matColumnDef="detail">
      <mat-header-cell *matHeaderCellDef>
        {{'headertable.detail_sign' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" matTooltip="{{element.status === 'error' || element.status === 'ERROR' ? element.errorMessage : ''}}"
                (click)="$event.stopPropagation()">
        <span class="fix-width">{{element.status === 'error' || element.status === 'ERROR' ? element.errorMessage : ''}}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"></mat-row>
  </mat-table>
</mat-dialog-content>
<mat-divider class="mt-2"></mat-divider>

<app-pagination class="my-3" [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)">
</app-pagination>

<mat-dialog-actions align="center" class="action">
  <button *ngIf="isProcess" mat-stroked-button color="primary" class="mr-3" (click)="onClickStop()" type="button"
          [disabled]="isStop">
    <mat-icon class="mr-0">block</mat-icon>
    {{'button.stop_progress' | translate}}
  </button>
  <button mat-stroked-button color="primary" class="mr-3" (click)="onClose()" type="button">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{'button.close' | translate}}
  </button>
</mat-dialog-actions>
